module.exports = __webpack_public_path__ + "static/img/bronze 2.164ba73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/bronze 2.png
// module id = FH5d
// module chunks = 35